<script>
  import { getNotificationsContext } from "svelte-notifications"
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import SectionCaption from "../../../../components/layout/SectionCaption.svelte";
  import Subsection from "../../../../components/layout/Subsection.svelte";
  import SubsectionTitle from "../../../../components/layout/SubsectionTitle.svelte";
  import HelpTooltip from "../../../../components/tooltip/HelpTooltip.svelte";
  import PrimaryBorderedButton from "../../../../components/button/generic/PrimaryBorderedButton.svelte";
  import ApplyLicenseFileDialog from "./ApplyLicenseFileDialog.svelte";
  import ActivateBackupLicenseDialog from "./ActivateBackupLicenseDialog.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import { downloadFile } from "../../../../utils/download.js";
  import { translate } from "../../../../i18n/i18next.js";
  import EProtectorDriverNotInstalledAlert
    from "../../../../components/licensing/EProtectorDriverNotInstalledAlert.svelte";

  export let onClose

  const {addNotification} = getNotificationsContext()

  let isApplyLicenseFileDialogOpen = false
  let isActivateBackupLicenseConfirmDialogOpen = false

  async function onClickRetrieveFingerprint() {
    const response = await fetch("/api/license/e-protector/fingerprint")
    const responseData = await response.json().catch(() => null)
    if (response.ok && responseData) {
      downloadFile(new Blob([responseData.content]), responseData.filename)
      addNotification({
        text: translate("frontend:components.initEProtectorLicenseAuthenticationDialog.messages.fingerprintDownloaded"),
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
    } else {
      addNotification({
        text: translate("frontend:components.initEProtectorLicenseAuthenticationDialog.messages.fingerprintDownloadFailed", null, {error: responseData?.type}),
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      });
    }
  }

</script>

<DialogTitle title={translate("frontend:components.initEProtectorLicenseAuthenticationDialog.title")}/>
<DialogSplitter/>
<DialogContent>
  <EProtectorDriverNotInstalledAlert />
  <!-- <EProtectorStatusAlert /> -->
  <SectionCaption>
    {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.caption1")}
    <!-- TODO: replace the link with the actual one
     <a href="{translate("frontend:components.initEProtectorLicenseAuthenticationDialog.caption2Href")}" style="text-decoration: underline">
       translate("frontend:components.initEProtectorLicenseAuthenticationDialog.caption2")
     </a>-->
  </SectionCaption>
  <DialogSplitter />
  <Subsection>
    <SubsectionTitle>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.retrieveFingerprint.title")}
    </SubsectionTitle>
    <SectionCaption>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.retrieveFingerprint.caption1")}
      <br/>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.retrieveFingerprint.caption2")}
    </SectionCaption>
    <div class="subsection-content-button">
      <HelpTooltip title={translate("generic.license.hasp.fingerprint")}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.retrieveFingerprint.tooltip")}
      </HelpTooltip>
      <PrimaryBorderedButton onClick={onClickRetrieveFingerprint}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.retrieveFingerprint.title")}
      </PrimaryBorderedButton>
    </div>
  </Subsection>
  <DialogSplitter />
  <Subsection>
    <SubsectionTitle>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.applyLicenseFile.title")}
    </SubsectionTitle>
    <SectionCaption>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.applyLicenseFile.caption")}
    </SectionCaption>
    <div class="subsection-content-button">
      <HelpTooltip title={translate("generic.license.hasp.licenseFile")}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.applyLicenseFile.tooltip")}
      </HelpTooltip>
      <PrimaryBorderedButton onClick={() => isApplyLicenseFileDialogOpen = true}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.applyLicenseFile.title")}
      </PrimaryBorderedButton>
    </div>
  </Subsection>
  {#if isApplyLicenseFileDialogOpen}
    <ApplyLicenseFileDialog onClose={() => isApplyLicenseFileDialogOpen = false}/>
  {/if}

  <!-- NOTE (25.2): To uncomment once all backup license related issues will be fixed

  <DialogSplitter />

  <Subsection>
    <SubsectionTitle>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.activateBackupLicense.title")}
    </SubsectionTitle>
    <SectionCaption>
      {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.activateBackupLicense.caption")}
    </SectionCaption>
    <div class="subsection-content-button">
      <HelpTooltip title={translate("generic.license.hasp.backupLicense")}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.activateBackupLicense.tooltip")}
      </HelpTooltip>
      <PrimaryBorderedButton onClick={() => isActivateBackupLicenseConfirmDialogOpen = true}>
        {translate("frontend:components.initEProtectorLicenseAuthenticationDialog.activateBackupLicense.title")}
      </PrimaryBorderedButton>
    </div>
    {#if isActivateBackupLicenseConfirmDialogOpen}
      <ActivateBackupLicenseDialog onClose={() => isActivateBackupLicenseConfirmDialogOpen = false}/>
    {/if}
  </Subsection>

  -->

</DialogContent>
<DialogSplitter/>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" onClick={onClose}>
    OK
  </DialogBottomControlButton>
</DialogBottomControls>

<style>
  .subsection-content-button {
    align-self: end;
  }
</style>
